<script lang="ts">
  import Heart from '@lucide/svelte/icons/heart';

  import { getServices } from '../../app/context';
  import type { ThemePreference } from '../../state/settings.svelte';
  import { strings } from '../../strings';
  import LegendBar from '../legend/LegendBar.svelte';
  import AppMenu from './AppMenu.svelte';
  import ProgressPill from './ProgressPill.svelte';
  import SearchBox from './SearchBox.svelte';
  import ThemeToggle from './ThemeToggle.svelte';
  import TitleInput from './TitleInput.svelte';

  const { settings } = getServices();
</script>

<header class="sticky top-0 z-30 border-b border-line bg-surface/95 backdrop-blur print:hidden">
  <div class="mx-auto flex h-14 max-w-[100rem] items-center gap-2 px-4">
    <h1 class="flex shrink-0 items-center gap-2 text-lg font-semibold">
      <Heart size={20} aria-hidden="true" class="fill-accent text-accent" />
      <span class="max-[379px]:sr-only">{strings.appName}</span>
    </h1>
    <span class="h-6 border-l border-line" aria-hidden="true"></span>
    <TitleInput class="w-40 sm:w-56" />
    <div class="flex-1"></div>
    <SearchBox class="hidden w-64 md:flex" />
    <ProgressPill class="hidden sm:flex" />
    <ThemeToggle
      value={settings.value.theme}
      onchange={(value: ThemePreference) => {
        settings.update({ theme: value });
      }}
    />
    <AppMenu />
  </div>
  <LegendBar />
</header>
